<div class="tab-content">
  <div class="documents-section">
    <!-- MANDATORY DOCUMENTS SECTION -->
    <div class="section-header">
      <h6>{{ "asset_form_drawer.documents.mandatory" | translate }}</h6>
    </div>
    <div class="documents-list documents-list--mandatory">
      <ng-container *ngFor="let req of mandatoryDocRequirements">
        <div class="doc-type-row no-doc" *ngIf="req.documents.length === 0">
          <div class="doc-type-content">
            <span class="doc-type-label">{{ req.document_type?.label }}</span>
            <span class="no-document-linked">{{ "asset_form_drawer.documents.no_document_linked" | translate }}</span>
          </div>
        </div>
        <div class="doc-type-row" *ngFor="let doc of req.documents; let i = index">
          <div class="doc-type-content">
            <span class="doc-type-label">{{ i === 0 ? req.document_type?.label : '' }}</span>
            <span class="other-doc-name" (click)="onOpenDocumentSheet(doc)">{{ doc.title }}</span>
          </div>
          <div class="doc-actions">
            <span class="other-doc-file-icon" (click)="onDownloadDocument(doc)">
              <fa-icon [icon]="faFileLines"></fa-icon>
            </span>
            <button class="delete-btn" (click)="onDeleteDocument($event, doc)" [attr.aria-label]="'Delete' | translate">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- OTHER DOCUMENTS SECTION -->
    <div class="section-header" style="margin-top: 32px;">
      <h6>{{ "asset_form_drawer.documents.other" | translate }}</h6>
    </div>
    <div class="documents-list">
      <ng-container *ngFor="let req of otherDocRequirements">
        <div class="doc-type-row" *ngFor="let doc of req.documents; let i = index">
          <div class="doc-type-content">
            <span class="doc-type-label--optional">{{ i === 0 ? req.document_type?.label : '' }}</span>
            <span class="other-doc-name" (click)="onOpenDocumentSheet(doc)">{{ doc.title }}</span>
          </div>
          <div class="doc-actions">
            <span class="other-doc-file-icon" (click)="onDownloadDocument(doc)">
              <fa-icon [icon]="faFileLines"></fa-icon>
            </span>
            <button class="delete-btn" (click)="onDeleteDocument($event, doc)" [attr.aria-label]="'Delete' | translate">
              <i class="fa-regular fa-trash-can"></i>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- FAB Button -->
  <button class="add-document-fab" (click)="onAttachNewDocument()" [title]="'Add a document' | translate">
    <i class="fa-thin fa-plus fa-2x"></i>
  </button>
</div>
